import body from "../../../index.module.scss";
import classes from "./FiveStep.module.scss";
import PinkBg from '../../PinkBlock/PinkBlock';
import SectionTitle from "../../Titles/SectionTitle/SectionTitle";
import StekList from './StekList/StekList';
import Image from '../../Image/Image';
import {ReactComponent as Arrow} from "../../Assets/Img/Src/Svg/arrow_left.svg"


import topol from "../../Assets/Img/Src/Stek/topolEco.png"
const FiveStep = () => {
  return (
    <section id="Technology" className={classes.FiveStep}>
        <PinkBg
         number={"5"}
          customClass={classes.TransparentBg}
          CustomNumClass={classes.Number}/>
    <div className={body.container}>
      <div className={classes.Wrap}>
        <SectionTitle 
          text={"Технологии"}
          customClass={classes.Title}
          />
          <p className={classes.Description}>
              Для получения описанного выше результата нами использовались следующие сервисы и программы:
          </p>
          <StekList/>
          </div>
    </div>
    <div className={classes.NextCase}>
      <Image src={topol}/>
      {/* <a href="/" className={classes.Link}>Смотреть дальше  */}
      <a href="#"  className={classes.Link}>Скоро </a>
      {/* <Arrow className={classes.Icon}/> */}      

    </div>
    </section>
  )
}
export default FiveStep;